export type LegalSection = {
  id: string;
  title: string;
  paragraphs: string[];
  list?: string[];
};

export const privacySections: LegalSection[] = [
  {
    id: 'who-we-are',
    title: 'Who we are',
    paragraphs: [
      'This privacy notice explains how [Company legal name], trading as Avenqor Talent Search (“Avenqor”, “we”, “us”), collects and uses personal information through this website. [Legal entity and registration details to be confirmed].',
    ],
  },
  {
    id: 'information-we-collect',
    title: 'Information we collect',
    paragraphs: ['Depending on how you interact with us, we may collect the following information:'],
    list: [
      'Employer inquiries: name, business email, company, role to be filled and a description of the hiring requirement.',
      'Candidate registrations: full name, professional email, current role, industry, years of experience, preferred role type, LinkedIn profile URL and, optionally, a CV or résumé.',
      'General enquiries: name, email, organization, nature of enquiry and message content.',
      'Technical information: [describe any analytics, cookies or server logs once confirmed].',
    ],
  },
  {
    id: 'how-we-use-information',
    title: 'How we use your information',
    paragraphs: [
      'We use employer information to respond to inquiries and to discuss potential search assignments.',
      'We use candidate information to assess whether your experience may be relevant to current or future searches, and to contact you about such opportunities. We will discuss a specific opportunity with you before [describe the circumstances in which candidate details may be shared with a client — to be confirmed].',
    ],
  },
  {
    id: 'lawful-basis',
    title: 'Lawful basis for processing',
    paragraphs: [
      '[To be confirmed by legal counsel — e.g. consent, legitimate interests and/or steps taken prior to entering into a contract, as applicable in each jurisdiction where Avenqor operates.]',
    ],
  },
  {
    id: 'sharing',
    title: 'Sharing your information',
    paragraphs: [
      'We do not sell personal information. We may share information with [service providers, e.g. hosting and applicant-tracking providers — to be confirmed] who process it on our behalf under appropriate contractual safeguards.',
    ],
  },
  {
    id: 'international-transfers',
    title: 'International transfers',
    paragraphs: [
      '[Describe any transfers of personal information outside the jurisdiction of collection and the safeguards relied upon.]',
    ],
  },
  {
    id: 'retention',
    title: 'How long we keep information',
    paragraphs: [
      'We keep personal information only for as long as necessary for the purposes described in this notice. [Specific retention periods for employer, candidate and enquiry records to be confirmed.]',
    ],
  },
  {
    id: 'security',
    title: 'Security',
    paragraphs: [
      'We intend to apply appropriate technical and organizational measures to protect personal information, including encryption in transit and restricted access. [Describe confirmed security measures once the submission system is implemented.]',
    ],
  },
  {
    id: 'your-rights',
    title: 'Your rights',
    paragraphs: [
      'Depending on where you live, you may have rights to access, correct, delete or restrict the use of your personal information, to object to processing, to data portability and to withdraw consent at any time. [Confirm applicable rights and the relevant supervisory authority.]',
    ],
  },
  {
    id: 'cookies',
    title: 'Cookies',
    paragraphs: ['[Describe the cookies and similar technologies used on this website, if any, and how preferences can be managed.]'],
  },
  {
    id: 'contact',
    title: 'Contact',
    paragraphs: ['Questions about this notice or your personal information can be submitted through the contact form on this website once secure submission is enabled.'],
  },
];

export const termsSections: LegalSection[] = [
  {
    id: 'acceptance',
    title: 'Acceptance of these terms',
    paragraphs: [
      'These terms govern your use of the Avenqor Talent Search website operated by [Company legal name]. By using this website you agree to these terms. If you do not agree, please do not use the website.',
    ],
  },
  {
    id: 'about-the-website',
    title: 'About this website',
    paragraphs: [
      'This website provides general information about the executive search and talent advisory services offered by Avenqor Talent Search. Content is provided for information only and does not constitute professional advice.',
    ],
  },
  {
    id: 'no-offer',
    title: 'No offer of employment',
    paragraphs: [
      'Nothing on this website constitutes an offer of employment or engagement. Registering your interest or submitting information does not guarantee contact, an introduction, an interview or a placement.',
    ],
  },
  {
    id: 'acceptable-use',
    title: 'Acceptable use',
    paragraphs: ['You agree not to:'],
    list: [
      'Submit information that is false, misleading or that you are not entitled to share',
      'Upload files containing malicious code',
      'Attempt to gain unauthorized access to the website or related systems',
      'Use the website in any way that breaches applicable law',
    ],
  },
  {
    id: 'intellectual-property',
    title: 'Intellectual property',
    paragraphs: [
      'The Avenqor name, logo, website design and content are owned by or licensed to [Company legal name]. You may not reproduce them without prior written permission.',
    ],
  },
  {
    id: 'third-party-links',
    title: 'Third-party links',
    paragraphs: [
      'Where this website links to third-party sites, those links are provided for convenience only. We are not responsible for the content or practices of third-party sites.',
    ],
  },
  {
    id: 'liability',
    title: 'Disclaimer and limitation of liability',
    paragraphs: ['[Disclaimer and limitation of liability wording to be drafted by legal counsel for the applicable jurisdiction.]'],
  },
  {
    id: 'governing-law',
    title: 'Governing law',
    paragraphs: ['These terms are governed by the laws of [jurisdiction to be confirmed].'],
  },
  {
    id: 'changes',
    title: 'Changes to these terms',
    paragraphs: ['We may update these terms from time to time. The current version will always be available on this page.'],
  },
  {
    id: 'contact',
    title: 'Contact',
    paragraphs: ['Questions about these terms can be submitted through the contact form on this website once secure submission is enabled.'],
  },
];
